import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { formatStopLocation } from '../../../../shared/utils/run';

const LocationDropdown = ({
    list,
    handleChange,
    disabled,
    rowNumber,
    selectedLocationId,
    location,
    isSpecial,
}) => (
    <div>
        {isSpecial ? (
            <p style={{ marginTop: 14 }}>{formatStopLocation(location)}</p>
        ) : (
            <FormControl
                componentClass="select"
                onChange={e => handleChange(e.target.value, rowNumber)}
                disabled={disabled}
                value={selectedLocationId}
            >
                <option value="">Select Location</option>
                {list.map(stop => (
                    <option key={stop.stopId} value={stop.stopId}>
                        {formatStopLocation(stop)}
                    </option>
                ))}
            </FormControl>
        )}
    </div>
);

LocationDropdown.propTypes = {
    list: PropTypes.array,
    handleChange: PropTypes.func,
    disabled: PropTypes.bool,
    selectedLocationId: PropTypes.string,
    rowNumber: PropTypes.number,
    isSpecial: PropTypes.bool,
    location: PropTypes.object,
};
LocationDropdown.defaultProps = {
    list: [],
    location: {},
};

export default LocationDropdown;
